import React from "react";

const BasicArrow = ({ fill, className }) => (
	<svg
		width="13"
		height="12"
		viewBox="0 0 13 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M7.80615 1.5L11.8062 6L7.80615 10.5"
			stroke={fill}
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<line y1="6" x2="11" y2="6" stroke={fill} strokeWidth="2" />
	</svg>
);

export default BasicArrow;
